import { ApiClient } from "../api.client";
import {
  GetFreeInvitesRequest,
  GetFreeInvitesResponse,
  ReplenishInvitesRequest,
  ReplenishInvitesResponse,
} from "./types";

const InvitesApi = {
  getFreeInvites(params: GetFreeInvitesRequest) {
    return ApiClient.get<GetFreeInvitesResponse>(
      `/admin/invites/count/${params.userId}`
    );
  },
  replenishInvites(body: ReplenishInvitesRequest) {
    return ApiClient.post<ReplenishInvitesRequest, ReplenishInvitesResponse>(
      `/admin/invites/replenish`,
      body
    );
  },
};

export { InvitesApi };
